import { MAP_LAYER_IDS } from '../../../lib/constants';

export default (dispatch) => ({
  clearSearchLayer() {
    dispatch({
      type: 'map/clearLayer',
      payload: MAP_LAYER_IDS.search
    });
  },

  addSearchGraphicToMap(graphic) {
    dispatch({
      type: 'map/addGraphicToMap',
      payload: {
        layerId: MAP_LAYER_IDS.search,
        graphic: graphic
      }
    });
  }
});